import App from "@/views/App.vue";

export default [
  {
    path: "/timeline",
    name: "timeline",
    component: App,
    redirect: { name: "timelineHome" },
    children: [
      {
        path: "/timeline/:id?",
        name: "timelineHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewTimeline.vue"),
        meta: {
          displayName: "displayName.timeline",
          requiresAuth: true,
        },
      },
      {
        path: "/postagem/:id/:commentId?",
        name: "timelinePost",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/CurrentPost.vue"),
        meta: {
          displayName: "displayName.currentPost",
          requiresAuth: true,
        },
      },
      {
        path: "/perfil-fournetwork",
        name: "timelineFourNetworkSection",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/FourNetworkSection.vue"
          ),
        meta: {
          displayName: "displayName.currentPost",
          requiresAuth: true,
        },
      },
    ],
  },
];
